import { createReactBlockSpec } from '@blocknote/react';

export function getHorizontalRulePresentation(_isEditable: boolean): {
  containerClassName: string;
  showDivider: boolean;
} {
  return {
    containerClassName: 'py-2',
    showDivider: true,
  };
}

export function resolveHorizontalRuleIsEditable({
  getIsEditable,
  editorIsEditable,
}: {
  getIsEditable?: () => boolean;
  editorIsEditable?: boolean;
}): boolean {
  const resolvedIsEditable = getIsEditable?.();

  if (typeof resolvedIsEditable === 'boolean') {
    return resolvedIsEditable;
  }

  if (typeof editorIsEditable === 'boolean') {
    return editorIsEditable;
  }

  return true;
}

export interface HorizontalRuleBlockSpecOptions {
  getIsEditable?: () => boolean;
}

export function createHorizontalRuleBlockSpec(
  options: HorizontalRuleBlockSpecOptions = {},
) {
  return createReactBlockSpec(
    {
      type: 'horizontalRule',
      propSchema: {},
      content: 'none',
    },
    {
      // BlockNote recommends `selectable: false` for `content: 'none'` React
      // block specs; without it, the selection plugin can call `getPos()` on
      // the React node view before ProseMirror has registered its position
      // (most reliably in read-only mounts), which throws
      // "Cannot find node position" and trips BlockNoteErrorBoundary.
      meta: { selectable: false },
      render: (props) => {
        const presentation = getHorizontalRulePresentation(
          resolveHorizontalRuleIsEditable({
            getIsEditable: options.getIsEditable,
            editorIsEditable: props.editor?.isEditable,
          }),
        );
        return (
          <div
            className={presentation.containerClassName}
            contentEditable={false}
            aria-hidden="true"
          >
            {presentation.showDivider ? (
              <hr
                className="border-border"
                data-testid="horizontal-rule-divider"
              />
            ) : null}
          </div>
        );
      },
      parse: (element: HTMLElement) => {
        if (element.querySelector('hr')) {
          return {};
        }
        return undefined;
      },
    },
  )();
}

export const horizontalRuleBlockSpec = createHorizontalRuleBlockSpec();
